import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';
import * as list from '../utils/list';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function notificationReducer(state = initialState.notifications, action) {
    let newState = state;

    switch (action.type) {
        case types.CREATE_NOTIFICATION:
            if (action.status === 'success'){
                newState = createNotification(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.DELETE_NOTIFICATION:
            if (action.status === 'success'){
                newState = deleteNotification(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.DELETE_ALL_NOTIFICATIONS:
            if (action.status === 'success'){
                newState = deleteAllNotifications(state);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_NOTIFICATIONS_PAGE:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    notifications: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_UNREAD_NOTIFICATIONS_PAGE_COUNT:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    numberOfUnreadNotifications: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.MARK_ALL_NOTIFICATIONS_AS_READ:
            if (action.status === 'success'){
                newState = markAllNotificationsAsRead(state);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.MARK_NOTIFICATION_AS_READ:
            if (action.status === 'success'){
                newState = markNotificationAsRead(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.MARK_NOTIFICATION_AS_UNREAD:
            if (action.status === 'success'){
                newState = markNotificationAsUnread(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.SET_LOADING_FLAG_FOR_NOTIFICATION_STATE:
            return Object.assign({}, state, {
                loading: true
            });

        case types.UNDELETE_NOTIFICATION:
            if (action.status === 'success'){
                newState = undeleteNotification(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        default:
            return state;
    }
}

function createNotification (state, notification) {
    return Object.assign({}, state, {
        loading: false,
        notifications:  [...state.notifications, notification],
        numberOfUnreadNotifications: state.numberOfUnreadNotifications++
    });
}

function deleteNotification (state, notificationID) {
    let notificationList = state.notifications;
    let numberOfUnreadNotifications = state.numberOfUnreadNotifications;
    let index = list.findIndexByID(notificationList, notificationID);

    if (!notificationList[index].read) {
      numberOfUnreadNotifications--;
    }

    notificationList[index].deleted = true;

    let newState = Object.assign({}, state, {
        loading: false,
        notifications: notificationList,
        numberOfUnreadNotifications: numberOfUnreadNotifications
    });
    return newState;
}

function deleteAllNotifications (state) {
    let notificationList = state.notifications;

    for (let n of notificationList) n.deleted = true;

    let newState = Object.assign({}, state, {
        loading: false,
        notifications: notificationList,
        numberOfUnreadNotifications: 0
    });
    return newState;
}

function markAllNotificationsAsRead (state) {
    let notificationList = state.notifications;

    for (let n of notificationList) n.read = true;

    let newState = Object.assign({}, state, {
        loading: false,
        notifications: notificationList,
        numberOfUnreadNotifications: 0
    });
    return newState;
}

function markNotificationAsRead (state, notificationID) {
    let notificationList = state.notifications;
    let index = list.findIndexByID(notificationList, notificationID);
    let numberOfUnreadNotifications = state.numberOfUnreadNotifications;

    if (!notificationList[index].read) {
      numberOfUnreadNotifications--;
    }
    notificationList[index].read = true;

    let newState = Object.assign({}, state, {
        loading: false,
        notifications: notificationList,
        numberOfUnreadNotifications: numberOfUnreadNotifications
    });
    return newState;
}

function markNotificationAsUnread (state, notificationID) {
    let notificationList = state.notifications;
    let index = list.findIndexByID(notificationList, notificationID);

    notificationList[index].read = false;

    let newState = Object.assign({}, state, {
        loading: false,
        notifications: notificationList,
        numberOfUnreadNotifications: ++state.numberOfUnreadNotifications
    });
    return newState;
}

function undeleteNotification (state, notificationID) {
    let notificationList = state.notifications;
    let numberOfUnreadNotifications = state.numberOfUnreadNotifications;
    let index = list.findIndexByID(notificationList, notificationID);

    if (notificationList[index].read === false)
        numberOfUnreadNotifications++;

    notificationList[index].deleted = false;

    let newState = Object.assign({}, state, {
        loading: false,
        notifications: notificationList,
        numberOfUnreadNotifications: numberOfUnreadNotifications
    });
    return newState;
}



/** WEBPACK FOOTER **
 ** ./src/app/reducers/notificationReducer.js
 **/